import { render, staticRenderFns } from "./Transaction_rules.vue?vue&type=template&id=12aacd78&scoped=true"
import script from "./Transaction_rules.vue?vue&type=script&lang=js"
export * from "./Transaction_rules.vue?vue&type=script&lang=js"
import style0 from "./Transaction_rules.vue?vue&type=style&index=0&id=12aacd78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aacd78",
  null
  
)

export default component.exports